import React, { KeyboardEvent, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import styles from './Search.module.scss'

export const Search = () => {
  const [searchText, setSearchText] = useState('')

  const history = useHistory()
  const location = useLocation()

  const handleSubmit = () => {
    const searchParam = new URLSearchParams(location.search)
    searchParam.set('query', searchText)
    history.push({ search: searchParam.toString() })
  }

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSubmit()
    }
  }
  return (
    <div style={{ width: '100%', paddingRight: '16px' }}>
      <div style={{ width: '100%', display: 'flex' }}>
        <input
          placeholder="Search"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onKeyDown={(e) => handleKeyDown(e)}
          className={styles.Input}
        />
        <button onClick={handleSubmit} className={styles.Button}>
          Search
        </button>
      </div>
    </div>
  )
}
